import { EntityState, Selector, createSelector } from '@reduxjs/toolkit'
import { IClientWithSettings, SimpleClient } from 'shared/models/Client'
import { UserRoleEnum } from 'shared/models/User'
import { RootState } from '../store'
import { getUser } from '../user/selectors'
import clientsApi from './clients.service'
import clientReducer, { clientsAdapter } from './reducer'

const _clientStore = (root: RootState) =>
  // @ts-expect-error todo companyinfo does not exist
  root[clientReducer.name] as EntityState<IClientWithSettings> & {
    currentId: string | null
    clients: SimpleClient[]
    isSettingClient: boolean
  }

const getAllClients = (root: RootState) =>
  clientsAdapter
    .getSelectors((x: RootState) => x[clientReducer.name])
    .selectAll(root)

export const getActiveClientId: Selector<RootState, string | null> =
  createSelector(_clientStore, ({ currentId }) => currentId)

export const getActiveClient: Selector<RootState, IClientWithSettings> =
  createSelector([getAllClients, _clientStore], (clients, { currentId }) => {
    if (!currentId) return

    return clients.find(
      (client: IClientWithSettings) => client.id === currentId
    )
  })

export const getClientSettings = createSelector(
  [getActiveClient],
  (client) => client?.portalAvailable || []
)

export const isPortaluserInActiveClient = createSelector(
  [getUser, getActiveClientId],
  (user, id) => {
    const role = user?.data?.roles.find((x) => x.role === UserRoleEnum.portal)
    if (role && id) return role.reference.some((x) => x.value === id)
    return false
  }
)

export const isTechnicalSupport = createSelector(
  [getUser, getActiveClientId],
  (user, id) => {
    const role = user?.data?.roles.find(
      (x: any) => x.role === UserRoleEnum.support
    )
    if (role && id) return role.reference.some((x: any) => x.value === id)
    return false
  }
)

export const getIsPortalLight = createSelector(
  [getActiveClient],
  (client) => client?.hasLightSystem || false
)

export const getClients = createSelector(_clientStore, ({ clients }) => clients)

export const clientApiSelector = (id: string | null) =>
  clientsApi.endpoints.getClient.select(id || '')

export const getIsSettingClient = createSelector(
  _clientStore,
  ({ isSettingClient }) => isSettingClient
)
